module.exports = __webpack_public_path__ + "img/us-b1.8bd7ed1b.png";